import React, { useEffect, useRef, useState } from "react";
import { Tag } from "@phosphor-icons/react";
import CurrencySwitcher from "../CurrencySwitcher";
import { api } from "../../lib/api";

/** Coupon ticker that lives at the very top of the page.
 * Pulls active coupons from the backend, auto-rotates every 5s, and supports
 * horizontal touch-swipe gestures on mobile. */
export default function HeaderTopbar() {
  const [coupons, setCoupons] = useState([]);
  const [idx, setIdx] = useState(0);
  const swipeRef = useRef({ startX: 0, lastX: 0, active: false });

  useEffect(() => {
    api.get("/coupons/public").then((r) => setCoupons(r.data || [])).catch(() => {});
  }, []);

  useEffect(() => {
    if (coupons.length < 2) return;
    const id = setInterval(() => setIdx((i) => (i + 1) % coupons.length), 5000);
    return () => clearInterval(id);
  }, [coupons]);

  const onTouchStart = (e) => {
    if (coupons.length < 2) return;
    const t = e.touches?.[0];
    if (!t) return;
    swipeRef.current = { startX: t.clientX, lastX: t.clientX, active: true };
  };
  const onTouchMove = (e) => {
    const t = e.touches?.[0];
    if (!t || !swipeRef.current.active) return;
    swipeRef.current.lastX = t.clientX;
  };
  const onTouchEnd = () => {
    const { startX, lastX, active } = swipeRef.current;
    swipeRef.current.active = false;
    if (!active || coupons.length < 2) return;
    const delta = lastX - startX;
    const THRESHOLD = 40;
    if (delta <= -THRESHOLD) {
      setIdx((i) => (i + 1) % coupons.length);
      try { navigator.vibrate?.(6); } catch (e) { console.debug("[Layout] vibrate unsupported:", e?.message || e); }
    } else if (delta >= THRESHOLD) {
      setIdx((i) => (i - 1 + coupons.length) % coupons.length);
      try { navigator.vibrate?.(6); } catch (e) { console.debug("[Layout] vibrate unsupported:", e?.message || e); }
    }
  };

  return (
    <div className="md-topbar" data-testid="site-topbar">
      <div className="md-container md-topbar-row">
        <div
          className="md-topbar-coupon-track"
          data-testid="topbar-coupon"
          onTouchStart={onTouchStart}
          onTouchMove={onTouchMove}
          onTouchEnd={onTouchEnd}
          onTouchCancel={onTouchEnd}
        >
          {coupons.length > 0 ? (
            <>
              <Tag size={12} weight="fill" />
              <span className="md-topbar-coupon-text" key={coupons[idx]?.code}>
                <strong>{coupons[idx].code}</strong> · {coupons[idx].description}
              </span>
              {coupons.length > 1 && (
                <span className="md-topbar-coupon-dots" data-testid="topbar-coupon-dots" aria-hidden>
                  {coupons.map((c, i) => (
                    <span key={c?.code || `coupon-dot-${i}`} className={i === idx ? "active" : ""} />
                  ))}
                </span>
              )}
            </>
          ) : (
            <>
              <Tag size={12} weight="fill" style={{ opacity: 0.6 }} />
              <span className="md-topbar-coupon-text" style={{ opacity: 0.85 }}>
                Cognitive flow, grounded care · welcome to MindDhara
              </span>
            </>
          )}
        </div>
        <CurrencySwitcher compact />
      </div>
    </div>
  );
}
